import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const GuaranteeSection: React.FC = () => {
  return (
    <SectionBackground style={{
      padding: '80px 20px',
      background: 'linear-gradient(135deg, #111827 0%, #1F2937 100%)',
      color: 'white',
    }}>
      <div className="container" style={{ maxWidth: '800px' }}>
        <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '30px', fontWeight: 700 }}>
          How We Support Compliance
        </h2>
        <div style={{
          background: 'rgba(255,255,255,0.1)',
          backdropFilter: 'blur(10px)',
          padding: '40px',
          borderRadius: '16px',
          border: '2px solid rgba(255,255,255,0.2)',
          color: 'white',
        }}>
          <p style={{ fontSize: '1.15rem', lineHeight: 1.8, marginBottom: '14px' }}>
            Templates are built around common California requirements and refreshed as laws change. Review and tailor them for your property before sending.
          </p>
        </div>
      </div>
    </SectionBackground>
  );
};

export default GuaranteeSection; 
